<app-title-component [data]="{name : 'Gestion du stock des Groupes'}"></app-title-component>

<mat-card appearance="outlined" class="main-table-card border-0 shadow-sm mt-5">
  <mat-card-header class="d-flex align-items-center justify-content-end p-3 border-bottom">
      <div class="mx-2 mt-4">
        <app-search-bar-component (searchBarValue)="applyFilter($event)"></app-search-bar-component>
      </div>
  </mat-card-header>

    <mat-card-content class="position-relative p-0 bg-white table-mat-card-content">
       @if (loading) {
        <div class="table-loading-overlay d-flex align-items-center justify-content-center">
          <mat-spinner diameter="48"></mat-spinner>
        </div>
        }

      <!---->
      <div>
      <div class="table-responsive">
        <table mat-table [dataSource]="dataSource" matSort class="w-100 custom-premium-table">
        <ng-container matColumnDef="groupe">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Groupe </th>
          <td mat-cell *matCellDef="let row"  data-label="Groupes"> {{row.groupe}} </td>
        </ng-container>
        <!-- -->

        <!-- -->
        <ng-container matColumnDef="qte">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Quantite </th>
          <td mat-cell *matCellDef="let row"  data-label="Qte"> {{row.qte }} </td>
        </ng-container>

        <!-- -->
        <ng-container matColumnDef="reste">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Reste </th>
          <td mat-cell *matCellDef="let row"  data-label="Reste"> {{row.reste }} </td>
        </ng-container>

        <!-- -->
        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Action </th>
          <td mat-cell *matCellDef="let row"  data-label="Action"> 
                <button mat-flat-button color="primary" (click)="openDetails(row)">Details</button>
          </td>
        </ng-container>


        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" ></tr>

        <!-- Row shown when there is no matching data. -->
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" colspan="4">No data matching the filter "{{searchValue()}}"</td>
        </tr>
            </table>
      </div>      </div>
  </mat-card-content>

  <div class="border-top bg-white">
      <mat-paginator [pageSizeOptions]="[6, 10, 25, 100]" aria-label="Select page of users"></mat-paginator>
  </div>
</mat-card>